import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { typeConfig, type FeedItem } from '@/types/homeFeed'

interface Props {
  item: FeedItem
}

const HomeFeedItem = ({ item }: Props) => {
  const cfg = typeConfig[item.type]
  const Icon = cfg.icon

  return (
    <Link
      to={item.ctaPath}
      className={`group flex items-center gap-3 rounded-2xl border px-4 py-3.5 transition-colors ${cfg.bg} ${cfg.border} hover:bg-white/[0.07]`}
    >
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
        style={{ background: `${cfg.color}20` }}
      >
        <Icon className="h-4 w-4" style={{ color: cfg.color }} />
      </div>
      <div className="flex-1 min-w-0">
        <p
          className="text-[10px] font-semibold tracking-wider uppercase"
          style={{ color: cfg.color }}
        >
          {cfg.label}
        </p>
        <p className="text-sm text-white leading-snug mt-0.5 truncate">{item.title}</p>
        <p className="text-[11px] text-gray-500 mt-0.5 truncate">{item.subtitle}</p>
      </div>
      <ChevronRight className="h-4 w-4 text-gray-500 group-hover:text-gray-300 shrink-0 transition-colors" />
    </Link>
  )
}

export default HomeFeedItem
